import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { getParameterByName } from 'helpers/url';
import { Spinner } from 'UI';
export var LTIComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var iframeSrc = document.location.origin + '/lti?start=y';

  var frameProps = _objectSpread({}, props);

  if (props.source != '') {
    iframeSrc += '&url=' + props.source;
  }

  if (props.lti_version != '') {
    iframeSrc += '&lti_version=' + props.lti_version;
  }

  if (props.lti_message_type != '') {
    iframeSrc += '&lti_message_type=' + props.lti_message_type;
  }

  if (props.content_item_return_url != '') {
    iframeSrc += '&content_item_return_url=' + encodeURI(props.content_item_return_url);
  }

  if (props.debug) {
    iframeSrc += '&debug=y';
  }

  delete frameProps.src;
  delete frameProps.source;
  delete frameProps.lti_message_type;
  delete frameProps.content_item_return_url;
  delete frameProps.lti_version;
  delete frameProps.debug;
  delete frameProps.ref;
  return /*#__PURE__*/React.createElement("iframe", _extends({
    onLoad: function onLoad(event) {
      var _event$target$content;

      if (event.target.contentWindow.haldor_lti == null) {
        return false;
      }

      var url = (_event$target$content = event.target.contentWindow.location) === null || _event$target$content === void 0 ? void 0 : _event$target$content.href;

      if (url != null && getParameterByName('start', url) == null) {
        // URL is available and start is not set on url (it has callback)
        var paramString = url.split('?')[1];
        var params_arr = paramString.split('&');
        var result = {};

        for (var i = 0; i < params_arr.length; i++) {
          var pair = params_arr[i].split('=');
          result[pair[0]] = decodeURIComponent(pair[1]);
        }

        props.onCallback(result);
      }
    }
  }, frameProps, {
    src: iframeSrc,
    ref: ref
  }));
});
LTIComponent.defaultProps = {
  source: '',
  lti_message_type: 'basic-lti-launch-request',
  content_item_return_url: document.location.origin + '/lti',
  lti_version: 'LTI-1p0',
  debug: false,
  onCallback: function onCallback() {
    return true;
  }
};
LTIComponent.propTypes = {
  source: PropTypes.string,
  lti_message_type: PropTypes.oneOf(['basic-lti-launch-request', 'ContentItemSelectionRequest']),
  content_item_return_url: PropTypes.string,
  lti_version: PropTypes.oneOf(['LTI-1p0', 'LTI-2p0']),
  debug: false,
  onCallback: PropTypes.func
};

var LTI = function LTI() {
  var formRef = useRef();
  var inputType = getParameterByName('debug') != null ? 'text' : 'hidden';
  useEffect(function () {
    window.haldor_lti = true;

    (function () {
      delete window.haldor_lti;
    });
  }, []);
  useEffect(function () {
    if (getParameterByName('debug') == null && formRef.current != null) {
      // Auto submit form
      formRef.current.submit();
    }
  }, [formRef]);

  if (getParameterByName('start') != null) {
    return /*#__PURE__*/React.createElement("form", {
      ref: formRef,
      method: "post",
      action: getParameterByName('url'),
      encType: "application/x-www-form-urlencoded"
    }, /*#__PURE__*/React.createElement("input", {
      name: "lti_message_type",
      type: inputType,
      value: getParameterByName('lti_message_type')
    }), /*#__PURE__*/React.createElement("input", {
      name: "content_item_return_url",
      type: inputType,
      value: getParameterByName('content_item_return_url')
    }), /*#__PURE__*/React.createElement("input", {
      name: "lti_version",
      type: inputType,
      value: getParameterByName('lti_version')
    }), /*#__PURE__*/React.createElement("input", {
      name: "ext_content_return_types",
      type: inputType,
      value: "lti_launch_url"
    }), /*#__PURE__*/React.createElement("input", {
      name: "launch_presentation_return_url",
      type: inputType,
      value: getParameterByName('content_item_return_url')
    }), getParameterByName('debug') != null ? /*#__PURE__*/React.createElement("button", {
      type: "submit"
    }, "Launch LTI") : null);
  }

  return /*#__PURE__*/React.createElement(Spinner, {
    center: true
  });
};

export default LTI;